"use strict";
exports.__esModule = true;
exports.isHardwareWallet = void 0;
var HARDWARE_WALLETS = ['trezor', 'ledger'];
var isHardwareWallet = function (wallet) {
    return HARDWARE_WALLETS.includes(wallet.toLowerCase());
};
exports.isHardwareWallet = isHardwareWallet;
